import {
  GET_PRODUCTS_BY_RUT_REQUEST,
  GET_PRODUCTS_BY_RUT_SUCCESS,
  GET_PRODUCTS_BY_RUT_FAILURE,
  CLEAR_PRODUCTS,
} from '../../api/Types';

const initialState = {
  collection: [],
  loading: false,
  count: 0,
  limit: 10,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_PRODUCTS_BY_RUT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_PRODUCTS_BY_RUT_SUCCESS:
      return {
        ...state,
        collection: action.payload.body,
        count: action.payload.count,
        limit: action.payload.limit,
        loading: false,
      };
    case GET_PRODUCTS_BY_RUT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case CLEAR_PRODUCTS:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
